import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    createFilterOptions,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, FileUploadOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { info } from "../../../ConfigInfo/Info";
import ErrorProps from "../../../Component/Errorprops";

const MenusModal = ({ mode, handleCloseClick, editData }) => {
    const [parentId, setParentId] = useState([]);
    // console.log('parent',parentId);
    const [loading, setLoading] = useState(false);
    const [masterName, setMasterName] = useState(
        mode === "Edit" ? editData.parentMenuName : ""
    );
    const [org, setOrgId] = useState([]);
    const [site, setSiteId] = useState([]);
    const OPTIONS_LIMIT = 10;
    const defaultFilterOptions = createFilterOptions();

    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
        return <Paper elevation={8} {...props} />;
    };
    console.log("editedata", editData);
    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);

        // if (mode === "Edit") {
        //     // getSite(editData.organizationId);
        // }
        // if (mode === "Edit" && editData.siteName === ""){
        //     getParentMenuForOrg(editData.organizationId)
        // } else {
        //     getParentMenuForSite(editData.siteId)
        // }
        getParentMenu()

        const orglink = masterAPI["organization"].link;
        await axiosPrivate
            .get(`${orglink}`)
            .then((res) => {
                setLoading(false);
                setOrgId(res.data.result);
            })
            .catch((e) => {
                setOrgId([]);
                setLoading(false);
                console.log(e, "siteerror");
            });
    };
    // const getSite = async (id) => {
    //     const link = masterAPI["site"].getallByOrgid;
    //     await axiosPrivate
    //         .get(`${link}/${id}`)
    //         .then((res) => {
    //             setLoading(false);
    //             setSiteId(res.data.result);
    //         })
    //         .catch((e) => {
    //             setSiteId([]);
    //             setLoading(false);
    //             console.log(e, "siteerror");
    //         });
    // };
    const getParentMenu = async (id) => {
        const link = masterAPI["menus"].getAllMenusSelectList;
        await axiosPrivate
            .get(`${link}`)
            .then((res) => {
                setLoading(false);
               console.log(res)
                setParentId(res.data);
            })
            .catch((e) => {
                setParentId([]);
                console.log(e, "createMenusgetAll");
            });
    };
    // const getParentMenuForSite = async (id) => {
    //     const link = masterAPI["menus"].getBySitId;
    //     await axiosPrivate
    //         .get(`${link}/${id}`)
    //         .then((res) => {
    //             setLoading(false);
    //             setParentId(res.data.result);
    //         })
    //         .catch((e) => {
    //             setParentId([]);
    //             console.log(e, "createMenusgetAll");
    //         });
    // };
    const initialValue = {
        code: mode === "Edit" ? editData.code : "",
        name: mode === "Edit" ? editData.name : "",
        href: mode === "Edit" ? editData.href : "",
        description: mode === "Edit" ? editData.description : "",
        displayOrder: mode === "Edit" ? editData.displayOrder : "",
        parentMenuId: mode === "Edit" ? editData.parentMenuId : null,
        isSubMenus: mode === "Edit" ? editData.isSubMenus:false,
        sequenceNumbers: mode === "Edit" ? editData.sequenceNumbers:"",
        siteId:  null,
        organizationId:null,
        icon: mode === "Edit" ? editData.icon : "",
        apiRoute: mode === "Edit" ? editData.apiRoute : "",
        module: mode === "Edit" ? editData.module : "",
    };

    const validationSchema = Yup.object().shape({
        code: Yup.string().required("Code is required"),
    });

    const onSubmit = async (value) => {
        console.log("onSubmit",value);
        setLoading(true);
        const createLink = masterAPI["menus"].create;
        const updateLink = masterAPI["menus"].update;
        if (mode === "Create") {
            await axiosPrivate
                .post(`${createLink}`, value)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "createMenus");
                });
        } else {
            const updateAC = {
                id: editData.id,
                ...value,
            };
            await axiosPrivate
                .put(`${updateLink}`, updateAC)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "updateMenus");
                });
        }
    };

    const handleCancel = () => {
        handleCloseClick();
    };

    return (
        <Box sx={{ p: color.masterPageDialogPadding }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        color: color.masterDialogTitleColor,
                        fontSize: color.masterDialogFontSize,
                    }}
                >
                    {mode === "Edit" ? editData.name : "New Menu"}
                </Typography>
                <IconButton onClick={handleCancel}>
                    <Clear />
                </IconButton>
            </Box>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
            <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ handleChange, setFieldValue, values, resetForm }) => (
                    <Form>
                        <Grid container spacing={"1rem"}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Code
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="code"
                                    placeholder="Enter Code"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            "&::placeholder": {
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                                <ErrorMessage name="code">
                                    {(error) => <ErrorProps>{error}</ErrorProps>}
                                </ErrorMessage>
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization
                </Typography>
                <Autocomplete
                  value={
                    values.organizationId
                      ? org.find((p) => p.id === values.organizationId) || null
                      : null
                  }
                  fullWidth
                  filterOptions={filterOptions}
                  loading={org.length === 0}
                  options={org}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.organizationName || ""
                  }
                  onChange={(event, value) => {
                    if (value) {
                      getSite(value.id);
                      getParentMenuForOrg(value.id);
                      setFieldValue("organizationId", value.id);
                    } else {
                      setFieldValue("organizationId", null);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="organizationId"
                      placeholder="Select Organization"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {org.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site
                </Typography>
                <Autocomplete
                  fullWidth
                  value={site.find((p) => p.id === editData.siteId) || null}
                  filterOptions={filterOptions}
                  loading={site.length === 0}
                  options={site}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.siteName || option
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      getParentMenuForSite(value.id);
                      setFieldValue("siteId", value.id);
                    } else {
                      setFieldValue("siteId", null);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="siteId"
                      placeholder="Select Site"
                      //  onChange={handleChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>

                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid> */}
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Name
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="name"
                                    placeholder="Enter Name"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Href
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="href"
                                    placeholder="Enter Href"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Description
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="description"
                                    placeholder="Enter Description"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Display Order
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="displayOrder"
                                    placeholder="Enter Display Order"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Api Route
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="apiRoute"
                                    placeholder="Enter API Route"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Parent Menu
                                </Typography>
                                {/* <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="parentMenuId"
                placeholder="Enter Asset Category Name"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.parentMenuId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >

                {parentId.map((id, i) => (
                  <MenuItem value={id.id} disabled={editData.id===id.id&&mode==="Edit"}>{id.name}</MenuItem>
                ))}
              </Field> */}
                                <Field
                                    name="parentMenuId"
                                    inputValue={masterName}
                                    component={Autocomplete}
                                    filterOptions={filterOptions}
                                    loading={parentId.length === 0}
                                    options={parentId}
                                    PaperComponent={CustomPaper}
                                    getOptionLabel={(option) => option.text || option}
                                    getOptionDisabled={(option) =>
                                        editData.id === option.id && mode === "Edit"
                                    }
                                    freeSolo
                                    onChange={(event, value) => {
                                        if (value) {
                                            console.log(value);

                                            setFieldValue("parentMenuId", value.value);
                                            setMasterName(value.text);
                                        } else {
                                            setFieldValue("parentMenuId", null);
                                            setMasterName("");
                                        }
                                    }}
                                    onInputChange={(e, v) => {
                                        setMasterName(v);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="parentMenuId"
                                            placeholder="Search Parent Menu"
                                            onChange={handleChange}
                                            size="small"
                                            // variant="standard"

                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                                        {parentId.length === 0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                >
                                    {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                                </Field>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Icon
                                </Typography>

                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="icon"
                                    placeholder="Enter Icon Path"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Module
                                </Typography>

                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="module"
                                    placeholder="Enter Module"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Sequence Number
                                </Typography>

                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="sequenceNumbers"
                                    placeholder="Enter Sequence Number"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid  container item xs={12} md={6} alignItems={"flex-end"}>
                                <FormControlLabel
                                    value="meter"
                                    checked={values.isSubMenus}
                                    control={<Checkbox onChange={(e)=>{
                                        setFieldValue("isSubMenus",e.target.checked)
                                        // setFieldValue("parts",false)
                                        // setFieldValue("techAttribute",false)
                                        // setFieldValue("tools",false)
                                        // setFieldValue("services",false)
                                    }} />}
                                    label="Is Submenu"
                                    sx={{
                                        ".MuiFormControlLabel-label":  {
                                            // Change color here
                                            color: color.labelColor
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid
                                container
                                item
                                xs={12}
                                justifyContent={"flex-end"}
                                gap="1rem"
                            >
                                <Button
                                    onClick={handleCancel}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: color.TableCancelButton,
                                        textTransform: "none",
                                        color: color.CancelTextColor,
                                        ":hover": {
                                            backgroundColor: color.TableCancelButton,
                                            textTransform: "none",
                                            color: color.CancelTextColor,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type={"submit"}
                                    variant="contained"
                                    disabled={loading}
                                    sx={{
                                        textTransform: "none",
                                        backgroundColor: loading
                                            ? "default"
                                            : color.TableButtonColor,
                                        "&:hover": {
                                            backgroundColor: loading
                                                ? "default"
                                                : color.buttonDisable,
                                        },
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default MenusModal;
